import { computed } from 'vue'

import useConversations from '@/features/chat/hooks/use-conversations.hook'

function useGroupConversationsWithoutFirstMessage() {
  const { conversationsRef, isPendingRef: isConversationsPendingRef } = useConversations()

  // get the conversations that are group conversations and have no messages sent
  const groupConversationsWithoutFirstMessageSentRef = computed(() =>
    conversationsRef.value.filter((conversation) => {
      // tous programmes : on se base sur la conversation, pas sur les groupes du programme selectionne
      return !!conversation.groupId && !conversation.messages.length
    }),
  )

  return {
    groupConversationsWithoutFirstMessageSentRef,
    isConversationsPendingRef,
  }
}

export default useGroupConversationsWithoutFirstMessage
